import axios from 'axios'

function makeGet(log, _axios) {
  return async (url, errorDefault) => {
    try {
      const res = await _axios.get(url)
      return res?.data
    } catch (error) {
      log(error)
      return errorDefault
    }
  }
}

function makePost(log, _axios) {
  return async (url, params, errorDefault) => {
    try {
      const res = await _axios.post(url, params)
      return res?.data
    } catch (error) {
      log(error)
      return errorDefault
    }
  }
}

function makePut(log, _axios) {
  return async (url, params, headers, errorDefault) => {
    try {
      const res = await _axios.put(url, params, headers)

      return res?.data
    } catch (error) {
      log(error)
      return errorDefault
    }
  }
}

function makeDelete(log, _axios) {
  return async (url, errorDefault) => {
    try {
      const res = await _axios.delete(url)
      return res?.data
    } catch (error) {
      log(error)
      return errorDefault
    }
  }
}

export default function request({ _axios=axios, _log }) {
  let log = (error) => console.error(error)

  if(_log) {
    log = _log
  }

  return { _get: makeGet(log, _axios), _post: makePost(log, _axios), _put: makePut(log, _axios), _delete: makeDelete(log, _axios) }
}
